module.exports = __webpack_public_path__ + "static/we-logo-37485a4a24bda0a9c26612a795bee7f2.png";